import dayjs from 'dayjs';

import { MAILBOX_RULE_BUSINESS_DAYS } from './ecdEstimate.constants';

const SATURDAY = 6;
const SUNDAY = 0;

const toDayjs = value => {
  if (!value) {
    return null;
  }

  const parsed = dayjs(value);

  return parsed.isValid() ? parsed.startOf('day') : null;
};

const toHolidaySet = holidays =>
  new Set(
    (holidays ?? [])
      .map(toDayjs)
      .filter(Boolean)
      .map(day => day.format('YYYY-MM-DD')),
  );

const isBusinessDay = (day, holidaySet) => {
  const weekday = day.day();

  if (weekday === SATURDAY || weekday === SUNDAY) {
    return false;
  }

  return !holidaySet.has(day.format('YYYY-MM-DD'));
};

const advanceBusinessDays = (cursor, remaining, holidaySet) => {
  if (remaining <= 0) {
    return cursor;
  }

  const next = cursor.add(1, 'day');

  return isBusinessDay(next, holidaySet)
    ? advanceBusinessDays(next, remaining - 1, holidaySet)
    : advanceBusinessDays(next, remaining, holidaySet);
};

export const addTridBusinessDays = (value, count, holidays = []) => {
  const start = toDayjs(value);

  if (!start || !Number.isFinite(count) || count <= 0) {
    return start;
  }

  return advanceBusinessDays(start, count, toHolidaySet(holidays));
};

export const estimateEarliestClosing = ({
  baseEarliestClosingDate,
  sendDate,
  anyMail = false,
  holidays = [],
} = {}) => {
  const baseDate = toDayjs(baseEarliestClosingDate);
  const send = toDayjs(sendDate) ?? dayjs().startOf('day');
  const mailboxDelayDays = anyMail ? MAILBOX_RULE_BUSINESS_DAYS : 0;

  const mailReceiptDate = anyMail
    ? addTridBusinessDays(send, MAILBOX_RULE_BUSINESS_DAYS, holidays)
    : null;

  if (!baseDate) {
    return {
      hasEstimate: false,
      isEstimated: true,
      anyMail,
      mailboxDelayDays,
      baseDate: null,
      estimatedDate: null,
      mailReceiptDate: mailReceiptDate ? mailReceiptDate.toDate() : null,
    };
  }

  const estimatedDate = mailboxDelayDays
    ? addTridBusinessDays(baseDate, mailboxDelayDays, holidays)
    : baseDate;

  return {
    hasEstimate: true,
    isEstimated: true,
    anyMail,
    mailboxDelayDays,
    baseDate: baseDate.toDate(),
    estimatedDate: estimatedDate.toDate(),
    mailReceiptDate: mailReceiptDate ? mailReceiptDate.toDate() : null,
  };
};
